import DepartmentForm from './DepartmentForm'

const Create = () => {
    return (
        <DepartmentForm
            config={{
                submitSuccessMsg: {
                    header: 'Created',
                    message: 'Department created successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to create department',
                },
                saveButton: {
                    label: 'Create',
                    savingLabel: 'Creating department...',
                },
            }}
        />
    )
}

export default Create
